import React from 'react';

import TextElement from './text-element';
import ImageWithPlaceholder from '../../shared/components/image-with-placeholder';

import '../css/split-content-box.less'

export default ({leftContent, rightContent, disclaimers=[]}) => {
    return(
        <div className='custom-component split-content-box'>
            <div className='left-side'>
            {
                leftContent.map((element, i) =>
                    <TextElement key={`split-content-box-text-${i}`} disclaimers={disclaimers} {...element} />)
            }
            </div>
            <div className='right-side'>
                <ImageWithPlaceholder className='image-wrapper' src={rightContent.imageUrl}/>
            </div>
        </div>
    )
}
